import { InterfaceMonitoringRepoImpl } from "domain/repository/InterfaceMonitoring/InterfaceMonitoringRepoImpl";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import { EbisInterfaceMonitoringMaintenanceVM } from "presentation/viewModel/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceVM";
import { useMemo } from "react";

export const useEbisInterfaceMonitoringMaintenanceVM = () => {
    const [, setEbisInterfaceMonitoringMaintenanceState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const ebisInterfaceMonitoringMainVM = useMemo(() =>
        EbisInterfaceMonitoringMaintenanceVM({
            dispatch: [setEbisInterfaceMonitoringMaintenanceState],
            repo: InterfaceMonitoringRepoImpl(),
        }), [setEbisInterfaceMonitoringMaintenanceState])

    return ebisInterfaceMonitoringMainVM
}
